import apiClient, { getApiErrorMessage } from '../../../api/apiClient';


export async function generateSizeReport(workflowRunId) {
  try {
    const response = await apiClient.post('/api/reports/size/', {
      workflow_run_id: workflowRunId,
    });
    return response.data;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Unable to generate report.'));
  }
}

export async function downloadReportPdf(reportId) {
  try {
    const response = await apiClient.get(
      `/api/reports/${encodeURIComponent(reportId)}/download/`,
      { responseType: 'blob' }
    );
    const filename = getDownloadFilename(
      response.headers?.['content-disposition'] ||
        response.headers?.['Content-Disposition'],
      reportId
    );
    const blob =
      response.data instanceof Blob
        ? response.data
        : new Blob([response.data], { type: 'application/pdf' });
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = objectUrl;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    try {
      link.click();
    } finally {
      link.remove();
      URL.revokeObjectURL(objectUrl);
    }
    return { filename };
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Unable to download report.'));
  }
}

function getDownloadFilename(contentDisposition, reportId) {
  const encodedMatch = String(contentDisposition || '').match(
    /filename\*=UTF-8''([^;]+)/i
  );
  if (encodedMatch) {
    try {
      const filename = sanitizeFilename(decodeURIComponent(encodedMatch[1]));
      if (filename) return filename;
    } catch {
      // Fall through to the regular filename or controlled fallback.
    }
  }

  const quotedMatch = String(contentDisposition || '').match(/filename="([^"]+)"/i);
  if (quotedMatch) {
    const filename = sanitizeFilename(quotedMatch[1]);
    if (filename) return filename;
  }

  const plainMatch = String(contentDisposition || '').match(/filename=([^;]+)/i);
  if (plainMatch) {
    const filename = sanitizeFilename(plainMatch[1]);
    if (filename) return filename;
  }

  const reportToken = String(reportId || '')
    .replace(/[^a-zA-Z0-9-]/g, '')
    .slice(0, 36);
  return `report-${reportToken || 'download'}.pdf`;
}

function sanitizeFilename(value) {
  const basename = String(value || '')
    .trim()
    .replace(/^['"]|['"]$/g, '')
    .split(/[\\/]/)
    .pop();
  if (!basename) return null;

  const safeName = basename.replace(/[^a-zA-Z0-9._-]/g, '-');
  if (!safeName) return null;
  return safeName.toLowerCase().endsWith('.pdf')
    ? safeName
    : `${safeName}.pdf`;
}
